import { Provider } from '@angular/core';
import { APP_LOAD } from '@core/contracts/app-load';
import { B2BUnitService } from '@b2b/features/b2b-unit/core/b2b-unit.service';

export const b2bUnitProviders: Provider[] = [
  {
    provide: APP_LOAD,
    useClass: B2BUnitService,
    multi: true,
  },
];
